/**
 * As réguas de campo do documento: um campo, um bloco ou uma lista deles só nasce
 * com dado dentro — o que a fonte não tem não vira rótulo vazio.
 */
import type { VoucherDocumentBlock, VoucherDocumentField } from './views/voucher_document_view.js';

/** Um campo que some sozinho quando não há valor. */
export function field(
  key: string,
  label: string,
  value: string | null | undefined,
  extra?: Partial<VoucherDocumentField>,
): VoucherDocumentField | null {
  const v = value?.trim();
  return v ? { key, label, value: v, ...extra } : null;
}

/** Descarta os campos que `field()` já apagou (`null`) — o filtro central que
 *  `block()` e o resto do arquivo reusam em vez de repetir o type guard. */
export function compact(fields: (VoucherDocumentField | null)[]): VoucherDocumentField[] {
  return fields.filter((f): f is VoucherDocumentField => f != null);
}

/** Um bloco só existe com campo dentro — senão sobraria o divisor órfão. */
export function block(
  key: string,
  fields: (VoucherDocumentField | null)[],
): VoucherDocumentBlock | null {
  const kept = compact(fields);
  return kept.length > 0 ? { key, fields: kept } : null;
}

/** Mesma régua do `compact()` de campos, um nível acima: descarta os blocos que
 *  `block()` já apagou por não terem campo nenhum dentro. */
export function compactBlocks(blocks: (VoucherDocumentBlock | null)[]): VoucherDocumentBlock[] {
  return blocks.filter((b): b is VoucherDocumentBlock => b != null);
}
